import { figma } from '../theme/figmaTokens';

/** Cards without a category use the blue HotQuus theme (#42). */
export const DEFAULT_HOTQUU_TILE_COLOR = figma.cyan;
